<template>
    <!-- 周选择时间控件 -->
    <div class="weekdatepicker">
        <mark
                style="position:fixed;top:0;bottom:0;left:0;right:0;background:rgba(0,0,0,0);z-index:999;"
                v-show="showWeek"
                @click.stop="showWeek=false"
        ></mark>
        <el-input placeholder="请选择周" v-model="showValue" style="width:220px;" @focus="showWeek=true"
                  :disabled="!editable">
            <i slot="prefix" class="el-input__icon el-icon-date"></i>
        </el-input>
        <el-card
                class="box-card"
                style="width:322px;padding: 0 3px 20px;margin-top:10px;position:fixed;z-index:9999"
                v-show="showWeek"
        >
            <div slot="header" class="clearfix" style="text-align:center;padding:0">
                <button
                        type="button"
                        aria-label="前一月"
                        class="el-picker-panel__icon-btn el-date-picker__prev-btn el-icon-d-arrow-left"
                        @click="prev"
                ></button>
                <span role="button" class="el-date-picker__header-label">{{year}}年 {{month}}月</span>
                <button
                        type="button"
                        aria-label="后一月"
                        @click="next"
                        class="el-picker-panel__icon-btn el-date-picker__next-btn el-icon-d-arrow-right"
                ></button>
            </div>
            <div class="text item" style="text-align:center;">
                <el-button
                        type="text"
                        size="medium"
                        style="width:40%;color: #606266;float:left;"
                        v-for="(week,index) in getWeeksWithYearAndMonth" :key="index" @click="selectWeek(index)"
                > {{week.summary}}
                    <br>
                    <span style="font-size: 12px;font-weight: bold">{{week.range}}</span>
                </el-button>
            </div>
        </el-card>
    </div>

</template>
<script type="text/javascript">
    import {mapState, mapActions} from 'vuex'

    export default {
        name: "weekdatepicker",
        props: {
            getValue: {
                default: val => {
                    return val;
                },
                type: Function
            },
            weekValue: {
                default: '',
                type: String
            },
            endDate: {
                default: '',
                type: String
            },
            startDate: {
                default: '',
                type: String
            },
            editable: {
                default: true,
                type: Boolean
            }
        },
        data() {
            return {
                showWeek: false,
                week: '',
                valueArr: [],
                weekIdxArr: [],
                year: this.$route.params.startDate ? new Date(this.$route.params.startDate).getFullYear() : (new Date().getFullYear()),
                month: this.$route.params.startDate ? (new Date(this.$route.params.startDate).getMonth() + 1) : (new Date().getMonth() + 1),
                dateValue: this.$route.params.dateValue,
                showValue: '',
            }
        },
        created() {
            if (this.weekValue) {
                this.showValue = this.startDate + '-' + this.endDate;
                let weekIdx = this.getWeek(this.startDate);

                this.$emit("fuc", this.startDate, this.endDate, weekIdx);
            }
        },
        computed: {
            ...mapState({
                new_plan_startDate: state => state.plan.new_plan_startDate,
                new_plan_endDate: state => state.plan.new_plan_endDate,
            }),
            getWeeksWithYearAndMonth() {
                let that = this;
                that.valueArr = [];
                that.weekIdxArr = [];
                let defaultDate = new Date(this.year + '-' + this.month + '-01');
                let month = defaultDate.getMonth() + 1;
                let years = defaultDate.getFullYear();
                let weeks = [];//现将星期数组重制一次
                let month2 = parseInt(month) - 1;
                let myDate = new Date(years, month2, 1);//获取每个月的第一天是星期几
                let firstDay = myDate.getDay();
                let myDate2 = new Date(years, month, 0);
                let days = myDate2.getDate();//获取每个月有多少天
                let firstMonday = '';
                let lastDay = '';
                //if(firstDay==0)firstDay=7;
                if (firstDay - 1 == 0) {
                    firstMonday = firstDay;
                    lastDay = days;
                } else {
                    firstMonday = 7 - firstDay + 2;
                    lastDay = days - (7 - firstDay + 1);
                }

                let weeksCount = Math.floor(lastDay / 7);
                let startIdx = 0;
                if (firstDay - 1 != 0) {
                    let week = new Object();
                    let startWeek = this.addDays(years + '/' + month + '/' + 1, -(7 - firstMonday + 1))
                    week.start = years + '/' + month + '/' + 1;
                    week.start = startWeek.getFullYear() + '/' + (startWeek.getMonth() + 1) + '/' + startWeek.getDate();
                    week.summary = '第' + this.getWeek(years + '/' + month + '/' + 1) + '周';
                    week.range = '(' + (startWeek.getMonth() + 1) + '/' + startWeek.getDate() + '-' + month + '/' + (firstMonday - 1) + ')';
                    week.value = this.getWeek(years + '/' + month + '/' + 1);
                    weeks.push(week);
                    that.valueArr.push(startWeek.getFullYear() + '/' + (startWeek.getMonth() + 1) + '/' + startWeek.getDate() + '-' + years + '/' + month + '/' + (firstMonday - 1));
                    that.weekIdxArr.push(this.getWeek(years + '/' + month + '/' + 1));
                    startIdx = 1;
                }

                let weekth = '';
                for (let i = 0; i < weeksCount; i++) {
                    weekth = i + 1 + startIdx
                    let week = new Object();
                    week.start = years + '/' + month + '/' + (firstMonday + 7 * i);
                    week.summary = '第' + this.getWeek(years + '/' + month + '/' + (firstMonday + 7 * i)) + '周';
                    week.range = '(' + month + '/' + (firstMonday + 7 * i) + '-' + month + '/' + ((firstMonday + 7 * i) + 7 - 1) + ')';
                    week.value = this.getWeek(years + '/' + month + '/' + (firstMonday + 7 * i));
                    that.valueArr.push(years + '/' + month + '/' + (firstMonday + 7 * i) + '-' + years + '/' + month + '/' + ((firstMonday + 7 * i) + 7 - 1));
                    that.weekIdxArr.push(this.getWeek(years + '/' + month + '/' + (firstMonday + 7 * i)));
                    weeks.push(week);
                }
                let shengyuDays = lastDay % 7;
                if (shengyuDays > 0) {
                    let week = new Object();
                    let endWeek = this.addDays(years + '/' + month + '/' + ((firstMonday + 7 * weeksCount) + shengyuDays - 1), (7 - shengyuDays))
                    week.start = years + '/' + month + '/' + (firstMonday + 7 * weeksCount);
                    week.end = endWeek.getFullYear() + '/' + (endWeek.getMonth() + 1) + '/' + endWeek.getDate();
                    week.summary = '第' + this.getWeek(years + '/' + month + '/' + (firstMonday + 7 * weeksCount)) + '周';
                    week.range = '(' + month + '/' + (firstMonday + 7 * weeksCount) + '-' + (endWeek.getMonth() + 1) + '/' + endWeek.getDate() + ')';
                    week.value = this.getWeek(years + '/' + month + '/' + (firstMonday + 7 * weeksCount));
                    that.valueArr.push(years + '/' + month + '/' + (firstMonday + 7 * weeksCount) + '-' + endWeek.getFullYear() + '/' + (endWeek.getMonth() + 1) + '/' + endWeek.getDate());
                    that.weekIdxArr.push(this.getWeek(years + '/' + month + '/' + (firstMonday + 7 * weeksCount)));
                    weeks.push(week);
                }
                return weeks;
            },
        },
        watch: {
            weekValue: function (value, oldValue) {
            },
            month: function (value, oldValue) {

            }
        },
        methods: {
            ...mapActions({
                change_new_plan_startDate: 'plan/change_new_plan_startDate',
                change_new_plan_endDate: 'plan/change_new_plan_endDate',
            }),
            addDays(theDateStr, days) {
                let d = new Date(theDateStr)
                d.setMilliseconds(d.getMilliseconds() + (days * 24 * 60 * 60 * 1000));
                return d;
            },
            one() {
                this.showWeek = false;
            },
            prev() {
                this.month = this.month * 1 - 1;
                if (this.month == 0) {
                    this.month = 12
                    this.year = this.year * 1 - 1
                }
            },
            next() {
                this.month = this.month * 1 + 1;
                if (this.month == 13) {
                    this.month = 1
                    this.year = this.year * 1 + 1
                }
            },
            selectWeek(i) {
                let that = this;
                let arr = that.valueArr[i];
                let arr2 = that.valueArr[i].split("-");
                let weekIdx = that.weekIdxArr[i];
                let startValue = arr2[0];
                let endDate = arr2[1];
                that.showWeek = false;
                this.showValue = that.getValue(arr);
                that.$emit("fuc", startValue, endDate, weekIdx); // 每次选择时间都将当前选择时间发送到父组件
                this.$emit("change", startValue);
            },
            getWeek: function (z) {//参数z是"2018-05-07 15:12:36"或者"2018/05/07 15:12:36"
                let day11 = new Date(z);
                day11.setMonth(0);
                day11.setDate(1);
                day11.setHours(0);
                day11.setMinutes(0);
                day11.setSeconds(0);//到这里就得到该年的一月一日

                let day11mill = day11.getTime();
                let ori_day = day11.getDay();//该年的一月一日是星期几
                let fill1 = 0;//与星期日相隔的毫秒数
                if (ori_day !== 0) {
                    fill1 = ori_day * 60 * 60 * 24 * 1000;
                }

                let now = Date.parse(z);
                now = new Date(now);
                now.setHours(0);
                now.setMinutes(0);
                now.setSeconds(0);
                let nowmill = now.getTime();
                let now_day = now.getDay();
                let fill2 = 0;
                if (now_day !== 0) {
                    fill2 = (7 - now_day) * 60 * 60 * 24 * 1000;
                }

                let cha2 = (nowmill - day11mill + fill1 + fill2) / (60 * 60 * 24 * 1000);
                let week = Math.ceil(cha2 / 7);
                if (week < 10) {
                    week = "0" + week;
                }
                return week;
            }
        },
        mounted() {
            if (typeof (this.startDate) != "undefined")
                this.change_new_plan_startDate(this.startDate)
            else this.startDate = this.new_plan_startDate

            if (typeof (this.endDate) != "undefined")
                this.change_new_plan_endDate(this.endDate)
            else this.endDate = this.new_plan_endDate
            this.dateValue = this.startDate
            this.year = new Date(this.startDate).getFullYear()
            this.month = new Date(this.startDate).getMonth() + 1
            let weekIdx = this.getWeek(this.startDate);
            this.showValue = this.startDate + '-' + this.endDate;
            this.$emit("fuc", this.startDate, this.endDate, weekIdx);
        }
    };

</script>
<style type="text/css" scoped>
    .weekdatepicker {
        display: inline;
    }

    .text {
        text-align: center;
        margin: 15px 0 10px;
    }

    .item {
        text-align: center;
    }

</style>
<style lang="scss">
    .weekdatepicker {
        .el-card__header {
            padding: 12px;
        }
    }

    .el-card__body .text.item {
        margin-top: 0 !important;
    }
</style>
